var moduleMap = {
	"./Logout": () => {
		return Promise.all([__webpack_require__.e(935), __webpack_require__.e(7104), __webpack_require__.e(7940), __webpack_require__.e(1909), __webpack_require__.e(5042), __webpack_require__.e(4061), __webpack_require__.e(2805), __webpack_require__.e(4692)]).then(() => (() => ((__webpack_require__(69064)))));
	},
	"./ErrorsPage": () => {
		return Promise.all([__webpack_require__.e(935), __webpack_require__.e(6705), __webpack_require__.e(7104), __webpack_require__.e(8042), __webpack_require__.e(7940), __webpack_require__.e(5470), __webpack_require__.e(1909), __webpack_require__.e(5042), __webpack_require__.e(4061), __webpack_require__.e(2805), __webpack_require__.e(9802), __webpack_require__.e(4466), __webpack_require__.e(3703)]).then(() => (() => ((__webpack_require__(76222)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});